<script lang="ts">
    import { getContext } from "svelte";
    import type { Writable } from "svelte/store";
    import { getImageURL, Metadata } from "../../helpers/metadata";

    let metadata = getContext<Writable<Metadata>>("metadata");
    export let style = ""


     
</script>

{#if $metadata}
    <img src={getImageURL($metadata)} alt="nft" {style}/>
{/if}
